import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';

export type SectionLeftInfoImg = {
    src: string;
    srcDesktop?: string;
    srcPad?: string;
    srcMobile?: string;
};

export type SectionLeftInfoProps = {
    id?: string;
    title: string;
    desc: string;
    img: SectionLeftInfoImg;
    className?: string;
    /** 有值时展示按钮 */
    btnText?: string;
    btnLink?: string;
};

export default function SectionLeftInfo({ id, title, desc, img, className, btnText, btnLink }: SectionLeftInfoProps) {
    return (
        <div id={id} className={`section-left-info ${css['section-left-info']}${className ? ` ${className}` : ''}`}>
            <div className="img-box">
                <EFPicture src={img.src} srcDesktop={img.srcDesktop} srcPad={img.srcPad} srcMobile={img.srcMobile} alt={title} />
                <div className="text-content">
                    <p className="title">{title}</p>
                    <p className="desc">{desc}</p>
                    {!!btnText && !!btnLink && (
                        <a className="btn" href={btnLink} target="_blank" rel="noreferrer">
                            <span className="btn-text">{btnText}</span>
                            <svg className="btn-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6 3.5L10.5 8L6 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}
